// extracted by mini-css-extract-plugin
export default {"rectangleSkeleton":"style_rectangleSkeleton__ggbd9","gradient-animation":"style_gradient-animation__on8Ak"};